import "./HotelTechnology.module.css";
import Header from "@/reusable_sections/Header";
import TechnologyImplementationFaq from "./sections/TechnologyImplementationFaq";
import Consultation from "./sections/Consultation";
import TechHospitalityHero from "./sections/TechHospitalityHero";
import Testimonials from "./sections/Testimonials";
import Technology from "./sections/Technology";
import Footer from "@/reusable_sections/Footer";
export default function HotelTechnologyPage() {
  return <div>
      <Header />
      <TechnologyImplementationFaq />
      <Consultation />
      <TechHospitalityHero />
      <Testimonials />
      <Technology />
      <Footer />
    </div>;
}